













































































































































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import PersonDetailBase from "./PersonDetailBase";
import ContactList from "./ContactList.vue";
import Extended from "./AttributeValueList.vue";
import TrainingList from "../Training/TrainingList.vue";
import EmploymentList from "../Employment/EmploymentEditList.vue";

@Component({
	components: {
		"contact-list": ContactList,
		"extended-list": Extended,
		"employment-list": EmploymentList,
		"training-list": TrainingList
	}
})
export default class PersonDetail extends PersonDetailBase {


	created() {
		super.created();
		super.initializeRights('COR_Person_Create', 'COR_Person_Delete', 'COR_Person_Read', 'COR_Person_Update');
		super.setMainDescriptionOld('Nový pracovník', 'Detail pracovníka', 'Úprava pracovníka', 'Smazání pracovníka');
		super.setAlertModalId('alertModalIdT');
		this.goBackUser = this.$router.currentRoute.params.goBack == 'user';
		this.formData.id = this.$router.currentRoute.params.id == undefined ? this.formData.id : this.objectIdFromParam;

		if (!this.styleFormNew && this.hasRight) {
			this.fetchData();
		}					
	}

	mounted() {
		super.mounted();
	};

	


}
